import React from 'react'
import { Link } from 'react-router-dom'
import { InputGroup, Button } from '../../UI'

const SignInForm = ({
  handleInput,
  formData: { first_name, last_name, email, password, admin, confirm_password, phone_number },
  loading,
  password_error,
  confirm_password_error,
  setConfirm_password_error,
   setPassword_error
}) => {
  return (
    <>
      <InputGroup
        label="First name"
        name="first_name"
        required={true}
        placeholder={'Enter your first name'}
        value={first_name ? first_name : ''}
        onChange={handleInput}
        error={false}
      />
      <InputGroup
        label="Last name"
        name="last_name"
        required={true}
        placeholder={'Enter your last name'}
        value={last_name ? last_name : ''}
        onChange={handleInput}
        error={false}
      />
      <InputGroup
        label="Email address"
        name="email"
        type="email"
        required={true}
        placeholder={'Enter your email name'}
        value={email ? email : ''}
        onChange={handleInput}
        error={false}
      />
      <InputGroup
        label="Phone number"
        name="phone_number"
        type="tel"
        required={true}
        placeholder={'Enter your phone number'}
        value={phone_number ? phone_number : ''}
        onChange={handleInput}
        error={false}
      />
      <InputGroup
        componentType="password"
        label="Password"
        name="password"
        autoComplete="current-password"
        type="password"
        value={password ? password : ''}
        required={true}
        placeholder="*******"
        onChange={handleInput}
        error={password_error}
        seterror={setPassword_error}
      />
       <InputGroup
        componentType="password"
        label="Confirm Password"
        name="confirm_password"
        autoComplete="current-password"
        type="password"
        value={confirm_password ? confirm_password : ''}
        required={true}
        placeholder="*******"
        onChange={handleInput}
        error={confirm_password_error}
        seterror={setConfirm_password_error}
        
      />

      <Button
        full
        type="submit"
        className="auth--btn"
        loading={loading}
        spinnerWithTxt={true}
      >
        Sign up
      </Button>
      <footer>
        <p>
          Already have an account? <Link to="/auth/sign-in">Log In</Link>
        </p>
      </footer>
    </>
  )
}

export default SignInForm
